export default __webpack_public_path__ + "static/media/person-logo-male.e6ea554e.svg";